import { Box } from '@factorialco/deprecated-design-system'
import { OneEmptyState } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

const ImportInProgress = () => {
  return (
    <Box
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap={'s16'}
      height="full"
    >
      <OneEmptyState
        title={i18n.t('job_catalog.job_catalog_tree_import.in_progress.title')}
        description={i18n.t('job_catalog.job_catalog_tree_import.in_progress.description')}
        variant="info"
      />
    </Box>
  )
}

export default ImportInProgress
